import { useUser } from '../libs/security/useUser';
import { EksUser } from '../models/common';

export interface useUserEksResult extends EksUser {
  data: EksUser;
  isLoggedIn: boolean;
}

const useUserEKS = (): useUserEksResult => {
  const { user } = useUser();

  const eksUser = user?.profile
    ? {
        userId: user.profile.sub,
        name: user.profile.name,
        email: user.profile.user_name,
        language: user.profile.language,
        roles: user.profile.roles,
        customer: {
          customerId: user.profile.tenant,
          customerName: user.profile.tenant_name,
        },
      }
    : undefined;

  const isLoggedIn = user?.expires_at !== undefined;

  return { ...eksUser, data: eksUser, isLoggedIn } as useUserEksResult;
};

export default useUserEKS;
